module.exports = __webpack_public_path__ + "media/images/blue_dot-2409f7726af53673cdb68313535b3d7f.png";